import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";


@Component({
  selector: 'app-whats-on',
  templateUrl: './whats-on.component.html'
})
export class WhatsOnComponent implements OnInit {

  public slug;
  event = {};

  galleryOptions = [
    {
      width: '800px',
      height: '750px',
      thumbnailsColumns: 4,
      imagePercent: 80,
      thumbnailsPercent: 17,
      thumbnailsMargin: 5,
      thumbnailMargin: 5
    },
  ];

  galleryImages = [];
  event_images = [];

  constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.galleryImages = [];
      this.getEvent();
      this.getEventImages();
    });

  }

  getEvent() {
    this.http.get(Conf.API_URL + '/events/?slug=' + this.slug).subscribe(
        data => {
          if (data['results'].length) {
              this.event = data['results'][0];
          } else {
            this.router.navigateByUrl('/404');
            return false;
          }

        },
        error => {
          console.log(error.error)
        }
    );
  }


  getEventImages() {
    this.http.get(Conf.API_URL + '/event-images/?event__slug=' + this.slug).subscribe(
        data => {
          this.event_images = data['results'];

          var this_m = this;

          $.each(this.event_images, function (index, value) {
            this_m.galleryImages.push({
              small: value.image,
              medium: value.image,
              big: value.image
            })

          });

          // console.log(this.galleryImages)
        },
        error => {
          console.log(error.error)
        }
    );
  }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/whats-on/whats-on.component.ts